import { render } from "./SmallWidgetSvg.vue?vue&type=template&id=b25ad03c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__